<template>
  <div class="animated fadeIn" id="fechar-competencia">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-briefcase"></i> Fechamento de Competências
      </div>
      <div class="card-body">
        <meta-select id="input-demanda"
          label="Competência"
          name="demanda"
          v-model="detalhes.demanda"
          :disabled="aprovado || competenciaBloqueada"
          attr-id="id"
          attr-label="titulo"
          :options="demandas"
          select-label="Selecionar"
          deselect-label="Remover"
          placeholder="Selecionar..."
          ref="demanda">
        </meta-select>

      </div>
    </div>

    <notifications group="fechar-competencia" />
  </div>
</template>

<style lang="scss">
  // #fechar-competencia {
    // Estilos
  // }
</style>

<script>
import DatePicker from 'vue2-datepicker';
import Uteis from '@/mixins/utils.js';

export default {
  components: {
    DatePicker,
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      meses: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ],
      competencias: [],
    };
  },

  mounted() {
    this.getCompetencias();
  },

  methods: {
    async getCompetencias() {
      try {
        this.$events.$emit('loading', true);

        const { data: response } = await this.$http.get('/competencia');

        if (!response.success) {
          throw new Error();
        }

        this.competencias = this.montarCompetencias(response.competencias);
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar as competências', 'fechar-competencia');
      } finally {
        this.$events.$emit('loading', false);
      }
    },

    montarCompetencias(competencias) {
      return competencias.map((item) => {
        return `${this.meses[item.mes - 1]}/${item.ano}`;
      });
    },
  },
}
</script>
